<template>
  <components-table :view="view" :row-click-enabled="false"/>
</template>

<script>
import { mapState } from 'vuex'
import componentsTable from './table'

export default {
  components: {
    componentsTable
  },
  computed: {
    ...mapState('tenants', {
      view: '_archivedView'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/components/archived.vue